<div class="list-group" *appRole="['Usuarios.Ver']" >
    <button type="button" [routerLinkActive]="['active']" class="list-group-item list-group-item-action active">
<div class="with-icon">
  <mat-icon class="padding-icon">account_circle</mat-icon><span> Usuario</span>
</div>
</button>
</div>
